import { useNotificationsStore } from 'stores/notificationsStore';

export const useNotifications = () => {
  const notifications = useNotificationsStore(state => state.notifications);
  const addNotification = useNotificationsStore(
    state => state.addNotification,
  );
  const removeNotification = useNotificationsStore(
    state => state.removeNotification,
  );

  return {
    notifications,
    addNotification,
    removeNotification,
  };
};
